import t from "../../../../helpers/t";
import React from "react";

const WeekEndPrice = (props) => {
  const {
    priceLocal,
    onChangeForm,
    weekdayBegin,
    timeBeginHours,
    hours,
    timeBeginMinutes,
    minutes,
    weekdayEnd,
    timeEndHours,
    timeEndMinutes,
  } = props;
  return (
    <>
      <td className="weekend_price">
        <label style={{ float: "left" }}>{t("price", null, "capital")}</label>
        <input
          className="pricetariff-price input-group-field"
          type="text"
          name="amount"
          value={priceLocal.amount}
          onChange={(e) => onChangeForm(e)}
          style={{ float: "left", width: "60%", marginLeft: "5px" }}
        />
      </td>
      <td className="weekend_price standard-price-column" style={{ width: "140px" }}>
        <label style={{ float: "left", paddingTop: "40px", marginLeft: "-20px" }}>
          {t("from the")}
        </label>
        <select
          className="inbooma-select-box__input"
          name="weekdays_begin"
          style={{ minHeight: "50px", float: "left", width: "125px" }}
          onChange={(e) => onChangeForm(e)}
          value={weekdayBegin}
        >
          <option value="Mon">{t("monday")}</option>
          <option value="Tue">{t("tuesday")}</option>
          <option value="Wed">{t("wednesday")}</option>
          <option value="Thu">{t("thursday")}</option>
          <option value="Fri">{t("friday")}</option>
          <option value="Sat">{t("saturday")}</option>
          <option value="Sun">{t("sunday")}</option>
        </select>
        <select
          className="inbooma-select-box__input"
          name="times_begin_hour"
          style={{ minHeight: "50px", maxWidth: "55px", float: "left" }}
          onChange={(e) => onChangeForm(e)}
          value={timeBeginHours}
        >
          {hours.map((hour) => {
            return (
              <>
                <option key={hour} value={hour}>
                  {hour}
                </option>
              </>
            );
          })}
        </select>
        <label
          style={{ float: "left", paddingLeft: "35px", paddingTop: "10px", paddingRight: "5px" }}
        >
          {" "}
          :{" "}
        </label>
        <select
          className="inbooma-select-box__input"
          name="times_begin_minute"
          style={{ minHeight: "50px", maxWidth: "55px", float: "left" }}
          onChange={(e) => onChangeForm(e)}
          value={timeBeginMinutes}
        >
          {minutes.map((minute) => {
            return (
              <>
                <option key={minute} value={minute}>
                  {minute}
                </option>
              </>
            );
          })}
        </select>
      </td>
      <td style={{ width: "140px" }}>
        <label style={{ float: "left", paddingTop: "40px" }}>{t("till")}</label>
        <select
          className="inbooma-select-box__input"
          name="weekdays_end"
          style={{ minHeight: "50px", marginLeft: "6px", float: "left" }}
          onChange={(e) => onChangeForm(e)}
          value={weekdayEnd}
        >
          <option value="Mon">{t("monday")}</option>
          <option value="Tue">{t("tuesday")}</option>
          <option value="Wed">{t("wednesday")}</option>
          <option value="Thu">{t("thursday")}</option>
          <option value="Fri">{t("friday")}</option>
          <option value="Sat">{t("saturday")}</option>
          <option value="Sun">{t("sunday")}</option>
        </select>
        <select
          className="inbooma-select-box__input"
          name="times_end_hour"
          style={{ minHeight: "50px", maxWidth: "55px", float: "left" }}
          onChange={(e) => onChangeForm(e)}
          value={timeEndHours}
        >
          {hours.map((hour) => {
            return (
              <>
                <option key={hour} value={hour}>
                  {hour}
                </option>
              </>
            );
          })}
        </select>
        <label
          style={{ float: "left", paddingLeft: "35px", paddingTop: "10px", paddingRight: "5px" }}
        >
          {" "}
          :{" "}
        </label>
        <select
          className="inbooma-select-box__input"
          name="times_end_minute"
          style={{ minHeight: "50px", maxWidth: "55px", float: "left" }}
          onChange={(e) => onChangeForm(e)}
          value={timeEndMinutes}
        >
          {minutes.map((minute) => {
            return (
              <>
                <option key={minute} value={minute}>
                  {minute}
                </option>
              </>
            );
          })}
        </select>
      </td>
    </>
  );
};

export default WeekEndPrice;
